import React from "react";

export const RADIO_HELP_TITLE = "Rádio";

export function RadioHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> Organizar a comunicação por áudio entre
        escritório e operadores no campo — com canais por equipe ou função,
        histórico salvo e envio individual quando precisar falar com uma pessoa
        só.
      </p>
      <p>
        <strong>Canais e grupos (passo a passo):</strong>
      </p>
      <ol>
        <li>
          Na aba <strong>Canais</strong>, crie quantos canais fizer sentido —
          por exemplo: <em>Grupo Aplicação</em>, <em>Grupo Colheita</em>,{" "}
          <em>Grupo Plantio</em>.
        </li>
        <li>
          Em <strong>Operadores</strong>, marque quem participa de cada canal.
          Um operador pode entrar em um grupo, em vários ou em todos.
        </li>
        <li>
          No <strong>app de campo</strong>, o operador escolhe o canal em que
          vai falar (ou acompanha todos os que estiver inscrito).
        </li>
        <li>
          Na plataforma, ao enviar áudio, <strong>selecione o canal</strong>{" "}
          antes de falar — a mensagem vai só para quem está naquele grupo.
        </li>
        <li>
          Também é possível enviar áudio <strong>individualmente</strong> para
          um operador, sem usar o canal da equipe.
        </li>
      </ol>
      <p>
        <strong>Histórico de áudios:</strong>
      </p>
      <ul>
        <li>
          Tudo fica salvo na aba <strong>Áudios</strong> e no painel do mapa —
          nada se perde.
        </li>
        <li>
          Você pode ouvir de novo quantas vezes quiser, na ordem em que foram
          enviados.
        </li>
        <li>
          Se alguém estiver sem internet no momento do envio, a mensagem chega
          quando voltar a ter conexão.
        </li>
      </ul>
      <p>
        <strong>Dica — ambiente ruidoso:</strong> dentro da cabine da máquina,
        o ideal é usar <strong>headset com microfone</strong>. Assim a voz fica
        mais clara para quem ouve no escritório ou no app, mesmo com motor,
        vento ou barulho do implemento.
      </p>
    </>
  );
}
